import * as yup from "yup";
export const ReportBuyerSchema = yup.object().shape({
  report: yup.array().of(yup.string()),
});
